import { memo, useMemo, useState } from 'react'

const wrapperStyle = {
  marginBottom: 10,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap'
}

const inputStyle = {
  border: '1px solid #c7c7c7',
  borderRadius: 8,
  padding: '0 10px',
  fontSize: 13,
  outline: 'none',
  height: 34,
  boxSizing: 'border-box'
}

const GenericListFilter = ({
  value = {},
  onChange,
  vehicles = [],
  labels = {}
}) => {

const [tooltip, setTooltip] = useState(null)
const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })

const setField = (key, fieldValue) => {
  const next = { ...value, [key]: fieldValue }

  if (key === 'from' || key === 'to') {
    delete next.month
    delete next.year
  }

  if (key === 'month') {
    delete next.from
    delete next.to
    delete next.year
  }

  if (key === 'year') {
    delete next.from
    delete next.to
    delete next.month
  }

  onChange(next)
}

const clearField = (key) => {
  const next = { ...value }
  delete next[key]
  onChange(next)
}

const clearAll = () => onChange({})

const yearOptions = useMemo(() => {
  const yearNow = new Date().getFullYear()
  return Array.from({ length: 5 }, (_, i) => yearNow - i)
}, [])

const isFiltered = Object.values(value || {}).some(v => v && v !== '')

return (
<>
<div style={wrapperStyle}>

<select
value={value.vehicleId || ''}
onChange={(e) => {
  const v = e.target.value
  if (!v) clearField('vehicleId')
  else setField('vehicleId', v)
}}
style={{ ...inputStyle, minWidth: 140 }}
>
<option value="">{labels.allVehicles}</option>
{vehicles.map((vehicle) => (
  <option key={vehicle.value} value={vehicle.value}>
    {vehicle.label}
  </option>
))}
</select>

<input
type="date"
value={value.from || ''}
onClick={(e) => e.target.showPicker?.()}
onMouseEnter={() => setTooltip(labels.from)}
onMouseLeave={() => setTooltip(null)}
onMouseMove={(e) => setCursorPos({ x: e.clientX, y: e.clientY })}
onChange={(e) => {
  const v = e.target.value
  if (!v) clearField('from')
  else setField('from', v)
}}
style={{ ...inputStyle, width: 120 }}
/>

<input
type="date"
value={value.to || ''}
onClick={(e) => e.target.showPicker?.()}
onMouseEnter={() => setTooltip(labels.to)}
onMouseLeave={() => setTooltip(null)}
onMouseMove={(e) => setCursorPos({ x: e.clientX, y: e.clientY })}
onChange={(e) => {
  const v = e.target.value
  if (!v) clearField('to')
  else setField('to', v)
}}
style={{ ...inputStyle, width: 120 }}
/>

<input
type="month"
value={value.month || ''}
onClick={(e) => e.target.showPicker?.()}
onMouseEnter={() => setTooltip(labels.month)}
onMouseLeave={() => setTooltip(null)}
onMouseMove={(e) => setCursorPos({ x: e.clientX, y: e.clientY })}
onChange={(e) => {
  const v = e.target.value
  if (!v) clearField('month')
  else setField('month', v)
}}
style={{ ...inputStyle, width: 130 }}
/>

<select
value={value.year || ''}
onChange={(e) => {
  const v = e.target.value
  if (!v) clearField('year')
  else setField('year', v)
}}
style={{ ...inputStyle, width: 150 }}
>
<option value="">{labels.year}</option>
{yearOptions.map((year) => (
  <option key={year} value={String(year)}>
    {year}
  </option>
))}
</select>

<button
type="button"
onClick={clearAll}
onMouseEnter={(e) => {
  e.currentTarget.style.background = '#2da9a4'
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background = isFiltered ? '#3BC6C4' : '#f5f5f5'
  e.currentTarget.style.transform = 'scale(1)'
  e.currentTarget.style.boxShadow = isFiltered
    ? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
    : '0 1px 8px rgba(0,0,0,0.30)'
}}
onMouseDown={(e) => {
  e.currentTarget.style.transform = 'scale(0.96)'
  e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
}}
onMouseUp={(e) => {
  e.currentTarget.style.transform = 'scale(1)'
  e.currentTarget.style.boxShadow = isFiltered
    ? '0 2px 10px rgba(165,232,195,0.95)'
    : '0 1px 8px rgba(0,0,0,0.30)'
}}
style={{
  border: '1px solid #107c6b',
  background: isFiltered ? '#3BC6C4' : '#f5f5f5',
  borderRadius: 8,
  height: 34,
  padding: '0 12px',
  lineHeight: '34px',
  cursor: 'pointer',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  boxShadow: isFiltered
    ? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
    : '0 1px 8px rgba(0,0,0,0.30)',
  transition: 'transform 0.05s ease, box-shadow 0.1s ease'
}}
>
{labels.clear || 'Vymazať'}
</button>

</div>

{tooltip && (
<div
style={{
position: 'fixed',
top: cursorPos.y - 50,
left: cursorPos.x,
transform: 'translateX(-50%)',
background: 'rgba(0,0,0,0.85)',
color: '#E7DFEC',
padding: '8px 14px',
borderRadius: 12,
fontSize: 16,
whiteSpace: 'nowrap',
pointerEvents: 'none',
zIndex: 5000,
border: '1.5px solid #0A303B',
boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
display: 'flex',
alignItems: 'center',
lineHeight: 1
}}
>
{tooltip}
</div>
)}

</>
)
}

export default memo(GenericListFilter)